import { Controller } from "@hotwired/stimulus"

/**
 * Request Detail Controller
 *
 * Adds keyboard navigation to the request detail view.
 * - j/k: move between sections
 * - Enter: toggle the current section's <details>
 * - Escape: navigate back
 */
export default class extends Controller<HTMLElement> {
  static targets = ["section"]

  declare readonly sectionTargets: HTMLElement[]
  private currentIndex = 0

  connect() {
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  private handleKeydown = (event: KeyboardEvent) => {
    const tag = (event.target as HTMLElement)?.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return

    switch (event.key) {
      case "j":
        this.next()
        break
      case "k":
        this.prev()
        break
      case "Enter":
        this.toggleCurrent()
        break
      case "Escape":
        this.goBack()
        break
    }
  }

  private next() {
    if (this.currentIndex < this.sectionTargets.length - 1) {
      this.currentIndex++
      this.scrollToCurrent()
    }
  }

  private prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.scrollToCurrent()
    }
  }

  private scrollToCurrent() {
    this.sectionTargets.forEach((s, i) => s.classList.toggle("ring-2", i === this.currentIndex))
    this.sectionTargets[this.currentIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  private toggleCurrent() {
    const section = this.sectionTargets[this.currentIndex]
    const details = section?.querySelector("details")
    if (details) details.open = !details.open
  }

  private goBack() {
    window.history.back()
  }
}
